export const paperStyles = {
  width: '960px',
  padding: '24px',
  boxSizing: 'border-box',
}